import React from 'react';
import { Button } from '../UI/Button';
import { MessageSquare, Users, Briefcase, Award, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
interface AccessPointsProps {
  openPaymentForm?: () => void;
  openCorporateTrainingForm?: () => void;
}
export const AccessPoints = ({
  openPaymentForm,
  openCorporateTrainingForm
}: AccessPointsProps) => {
  return <section className="py-16 bg-gray-50" data-id="element-272">
      <div className="container mx-auto px-4" data-id="element-273">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-274">
          <h2 className="text-3xl font-bold mb-4 text-gray-800" data-id="element-275">
            Access Points into The Networking Salon
          </h2>
          <p className="text-gray-600" data-id="element-276">
            Choose your pathway into our community based on your goals and
            commitment level.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-277">
          {/* The Waiting Room */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-278">
            <div className="flex items-center mb-4" data-id="element-279">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-280">
                <MessageSquare size={24} className="text-gray-700" data-id="element-281" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-282">
                The Waiting Room
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-283">
              <span className="font-bold" data-id="element-284">Free Access</span> — An open,
              welcoming space for curious minds and aspiring community members.
              Connect with others, share ideas, and build early-stage
              relationships.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-285">
              <li data-id="element-286">Submit approved announcements</li>
              <li data-id="element-287">Connect with community members</li>
              <li data-id="element-288">Discover networking opportunities</li>
            </ul>
            <Link to="/waiting-room" className="mt-auto" data-id="element-289">
              <Button variant="outline" className="w-full" data-id="element-290">
                Join Waiting Room
              </Button>
            </Link>
          </div>
          {/* Event Pathway */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-291">
            <div className="flex items-center mb-4" data-id="element-292">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-293">
                <Users size={24} className="text-gray-700" data-id="element-294" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-295">Event Pathway</h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-296">
              <span className="font-bold" data-id="element-297">Paid Access</span> — Attend a Physical
              Networking Salon and gain access to our professional community.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-298">
              <li data-id="element-299">Includes ongoing networking via community channels</li>
              <li data-id="element-300">Access to Virtual Coffee Chats held every two months</li>
            </ul>
            <Link to="/events" className="mt-auto" data-id="element-301">
              <Button variant="outline" className="w-full" data-id="element-302">
                Attend In-Person Event
              </Button>
            </Link>
          </div>
          {/* Inner Circle */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-303">
            <div className="flex items-center mb-4" data-id="element-304">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-305">
                <Briefcase size={24} className="text-gray-700" data-id="element-306" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-307">
                Inner Circle Membership
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-308">
              <span className="font-bold" data-id="element-309">Our yearly subscription</span> — For
              those ready to go deeper.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-310">
              <li data-id="element-311">Includes all Event Pathway benefits</li>
              <li data-id="element-312">Access to the AI Tools Catalogue and Resource Hub</li>
              <li data-id="element-313">Four Mastermind Sessions yearly</li>
              <li data-id="element-314">
                Discounted access to Physical Events, Services, and Products
              </li>
              <li data-id="element-315">Group coaching + ongoing peer mentoring sessions</li>
            </ul>
            <Link to="/inner-circle" className="mt-auto" data-id="element-316">
              <Button className="w-full" data-id="element-317">Join Inner Circle</Button>
            </Link>
          </div>
          {/* Corporate Training */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full" data-id="element-318">
            <div className="flex items-center mb-4" data-id="element-319">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-320">
                <Building2 size={24} className="text-gray-700" data-id="element-321" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-322">
                Corporate Training
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-323">
              <span className="font-bold" data-id="element-324">For Organizations & Teams</span> —
              Transform your team with expert-led training programs.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-325">
              <li data-id="element-326">Networking & Collaboration</li>
              <li data-id="element-327">Artificial Intelligence & Digital Tools</li>
              <li data-id="element-328">Leadership & Strategic Communication</li>
              <li data-id="element-329">₦50,000 per participant per day</li>
              <li data-id="element-330">Minimum 5 participants</li>
            </ul>
            <Button variant="outline" className="w-full mt-auto" onClick={openCorporateTrainingForm} data-id="element-331">
              Request Training
            </Button>
          </div>
          {/* Lifetime Partner Access */}
          <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col h-full md:col-span-2" data-id="element-332">
            <div className="flex items-center mb-4" data-id="element-333">
              <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-334">
                <Award size={24} className="text-gray-700" data-id="element-335" />
              </div>
              <h3 className="text-xl font-bold text-gray-800" data-id="element-336">
                Lifetime Partner Access
              </h3>
            </div>
            <p className="text-gray-600 mb-4 flex-grow" data-id="element-337">
              <span className="font-bold" data-id="element-338">For long-term collaborators</span> —
              And past event participants.
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-6" data-id="element-339">
              <li data-id="element-340">Includes all Inner Circle benefits</li>
              <li data-id="element-341">Exclusive Digital Transformation Roadmap</li>
              <li data-id="element-342">Access to the Book Library and Summaries Podcast</li>
              <li data-id="element-343">One-on-one engagement, ideation, and branding support</li>
            </ul>
            <Link to="/lifetime-partner" className="mt-auto" data-id="element-344">
              <Button className="w-full" data-id="element-345">Get Lifetime Partner Access</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
};